import StoreIcon from "@redotech/redo-icons/building-01.svg";
import {
  riskLabels,
  ShopifyRiskAssessmentResult,
} from "@redotech/redo-model/fulfillments/shopify-fulfillment-schemas";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.fraudRisk;

export const FraudRiskFilter = (): ArrayStringTableFilter => ({
  type: entry.type,
  itemLabel: "risk",
  operators: [...entry.operators],
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  Icon: StoreIcon,
  values: [...entry.staticValues],
  dbSearch: false,
  display: (item: string) => {
    return riskLabels[item as ShopifyRiskAssessmentResult];
  },
  displayName: entry.displayName,
});
